<template>
  <div>
    <h4 class="title">Estados de Cuenta</h4>
    <div class="row row-responsive">
      <div class="column column-xs-100 column-sm-50">
        <label for="">Seleccione el año:</label>
        <span class="select">
          <select v-model="selectedYear">
            <option v-for="(year, index) in years"
             :key="index">{{year}}</option>
          </select>
          <span class="arrow"></span>
        </span>
      </div>
      <div class="column column-xs-100 column-sm-50">
        <label for="">Seleccione el mes:</label>
        <span class="select">
          <select id="month" v-model="selectedMonth">
            <option value="" disabled selected>---</option>
            <option
              v-for="month in date"
              :value="month.id"
              :key="month.id"
            >{{ `${translateMonth(month.created_at)}` }}</option>
          </select>
          <span class="arrow"></span>
        </span>
        <div v-if="isError" class="error">
          Seleccione un mes
        </div>
      </div>
      <div class="row">
        <div class="column">
          <button class="button float-right"
            @click.prevent="submitMonth()">
            Siguiente
          </button>
        </div>
      </div>
      <div class="row" v-if="showMFA">
        <div class="column column-50 column-offset-25" style="text-aling:center">
          <MFAHandler button="hideButton" v-on:tokenObtained="onClickedChild"></MFAHandler>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import MONTHS from '@/constants/months'
import MFAHandler from '@/components/MFAHandler'
import httpRequestMixin from '@/mixins/httpRequestMixin'
import mixins from '@/mixins/index'

export default {
  name: 'UserProfileStatement',
  components: {
    MFAHandler
  },
  mixins: [mixins, httpRequestMixin],
  data () {
    return {
      MONTHS,
      selectedMonth: '',
      selectedYear: new Date().getFullYear(),
      years: [],
      date: [],
      isError: false,
      hideButton: true,
      showMFA: false
    }
  },
  watch: {
    selectedYear: function () {
      this.getMonths()
    }
  },
  created () {
    this.getYears()
    this.getMonths()
  },
  methods: {
    onClickedChild: async function (token) {
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/investor/statement/info/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          id: this.selectedMonth,
          token
        }
      }
      const response = await this.httpRequest(options)
      if (response.status === 200) {
        this.showMFA = false
        let fileLink = document.createElement('a')
        fileLink.href = response.data.url
        fileLink.setAttribute('target', '_blanck')
        document.body.appendChild(fileLink)
        fileLink.click()
        document.body.removeChild(fileLink)
      } else {
        const message = this.convertArraytoString(response.data)
        this.modalError(message, 'warning')
      }
    },
    submitMonth: function () {
      this.isError = this.selectedMonth === ''
      if (!this.isError) {
        this.isError = false
        this.showMFA = true
      }
    },
    getMonths: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/investor/statements/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          created_at: this.selectedYear
        }
      }
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.date = response.data.results
      }
    },
    getYears: function () {
      const yearMax = this.selectedYear
      const yearMin = 2020

      for (let i = yearMax; i >= yearMin; i--) {
        this.years.push(i)
      }
    },
    translateMonth: function (date) {
      const id = Number(date.substr(-2))

      return MONTHS.data
        .filter(month => Number(month.id) === id)
        .map(month => month.month)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/userProfile/userProfileResume/UserProfileStatement.vue